import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';
import { Oferta } from '../lib/model/oferta';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  oferta: Oferta;

  constructor(public dataService: DataService) {
    this.oferta = dataService.preinscripcio.oferta;
  }

  ngOnInit() {
  }

  public canviIdioma(idioma: string) {
    console.log(idioma);
  }

}



// WEBPACK FOOTER //
// ./src/app/header/header.component.ts